import { render, staticRenderFns } from "./AtualizacoesCadastraisDash.vue?vue&type=template&id=056f59c5&"
import script from "./AtualizacoesCadastraisDash.vue?vue&type=script&lang=js&"
export * from "./AtualizacoesCadastraisDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports